import { Injectable, signal } from '@angular/core';

import { ProjectRole, Project } from '../models/api.models';

// Caller-role registry sourced from `caller_project_role` on `GET /admin/projects`.
// Missing field falls back to `'viewer'` (most-restrictive); backend 403 is the real gate.
@Injectable({ providedIn: 'root' })
export class ProjectsService {
  /** Map of project id → caller's strongest role on that project. */
  readonly roleByProjectId = signal<Map<string, ProjectRole>>(new Map());

  /** Replaces the role map from a project-list response (removes stale entries for dropped projects). */
  recordRoles(projects: readonly Project[]): void {
    const next = new Map<string, ProjectRole>();
    for (const p of projects) {
      next.set(p.id, p.caller_project_role ?? 'viewer');
    }
    this.roleByProjectId.set(next);
  }
}
